export const HEADER_HEIGHT = 48;

// Discrete map zoom levels, most to least zoomed out. At Tokyo latitude
// (~35.66°), these are roughly 5 km, 2 km, and 800 m on the scale bar.
export const MAP_ZOOM_LEVELS = [11.4, 12.7, 14] as const;
export const DEFAULT_MAP_ZOOM_INDEX = MAP_ZOOM_LEVELS.length - 1;

export const DEFAULT_MAP_CENTER = {
  longitude: 139.80959,
  latitude: 35.70993
} as const;
